// App constants
export const APP_NAME = 'Maifloer Technologies';
export const VERSION = '1.0.0';

// Contact Information
export const CONTACT_INFO = {
  phone: '+91-9880068566',
  email: 'teammaifloer@gmail.com',
  address: 'Maifloer Technologies, Dommasandra, Bengaluru, Karnataka 562125'
};

// Company Information
export const COMPANY_INFO = {
  name: 'Maifloer Technologies',
  tagline: 'Innovative Solutions for Tomorrow',
  copyright: 'Copyright © 2025 Maifloer'
};

// SEO Meta Data
export const SEO_META = {
  title: 'Maifloer Technologies - Innovative Solutions for Tomorrow',
  description: 'Leading technology company providing innovative solutions in construction, agriculture, and technology sectors.',
  keywords: 'technology, construction, agriculture, innovation, solutions, Bangalore, India',
  author: 'Maifloer Technologies',
  ogTitle: 'Maifloer Technologies - Innovative Solutions',
  ogDescription: 'Discover innovative technology solutions for construction, agriculture, and more.',
  ogImage: '/images/og-image.jpg'
};

// Navigation Items
export const NAV_ITEMS = [
  { id: 'home', label: 'Home', path: '/' },
  { id: 'about', label: 'About', path: '/about' },
  { id: 'contact', label: 'Contact', path: '/contact' },
  { id: 'mailfoer', label: 'Mailfoer', path: '/mailfoer' }
];

// Card Types
export const CARD_TYPES = {
  CONSTRUCTION: 'construction',
  AGRICULTURE: 'agriculture', 
  TECHNOLOGY: 'technology'
};

// Animation Settings
export const ANIMATION_CONFIG = {
  fadeInThreshold: 0.1,
  fadeInRootMargin: '0px 0px -100px 0px'
};

// Card Content
export const CARD_CONTENT = {
  farmstays: 'Maifloer Farmstays offers a unique escape into nature\'s embrace...',
  technologies: 'Maifloer Technologies is a cutting-edge technology company...',
  construction: 'Maifloer Constructions is a premier real estate development company...'
};

// Card Descriptions
export const CARD_DESCRIPTIONS = {
  technologies: 'End-to-end turnkey tech solutions built for speed, scale, and innovation.',
  farmstays: 'Eco-friendly farm stays offering peace, nature, and rustic comfort.',
  construction: 'Crafting quality apartments with comfort, design, and lasting value.'
};

// Card Colors
export const CARD_COLORS = {
  technologies: '#f59e42',
  farmstays: '#22c55e',
  construction: '#fde047'
};

// Text Content
export const TEXT_CONTENT = {
  tagline: 'INTERACT | INSPIRE',
  description: 'Maifloer is a forward-thinking parent brand committed to innovation, sustainability, and quality living',
  aboutIntro: 'At Maifloer, we pride ourselves on a customer-centered approach that prioritizes your schedule and budget without compromising quality. With competitive pricing and efficient timelines, our skilled team ensures seamless project management from planning to execution.',
  legacyTitle: 'Our Legacy and Expertise',
  legacyContent: 'Founded by Mr. Lenu George on May 2002, Maifloer brings over 25 years of experience in delivering excellence. Our journey has been marked by consistent growth and innovation. Today, Maifloer stands as a team of 50+ dedicated employees committed to providing top-notch services. Mr. George holds an MBA in Marketing Analysis, enabling us to set new benchmarks in the industry.',
  profileIntro: 'Lenu George is a multifaceted individual with various professional and personal pursuits.'
};

// Map Configuration
export const MAP_CONFIG = {
  embedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.8267!2d77.7749!3d12.9141!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDU0JzUwLjgiTiA3N8KwNDYnMjkuNiJF!5e0!3m2!1sen!2sin!4v1687022241551!5m2!1sen!2sin'
};